import API from '../..';

const ENTITY = 'proposals-list';

export const filterProposals = ({
    page = 1,
    perPage = 25,
    searchText = '',
    ordering = '-created_at',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            page,
            per_page: perPage,
            ordering,
            ...(searchText ? { search: searchText } : {}),
        },
    });
